import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Row, Col, Alert } from "reactstrap";
import { get } from "../../../api/axios"; // Assuming the same axios setup as earlier
import endpoints from "../../../api/endpoints"; // Assuming endpoints are defined similarly
import avatar from "../../../assets/images/personPlaceholder.png";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import Placeholder from "../../../assets/images/Placeholder.gif";
const MostVisitedGyms = () => {
  const [gyms, setGyms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMostVisitedGyms = async () => {
    try {
      setLoading(true);
      const response = await get(`${endpoints.gym}/mostfavourite?filter=visit`);
      if (response.data) {
        setGyms(response.data.data || []);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load gyms. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMostVisitedGyms();
  }, []);

  return (
    <Card
      className="visited-gyms-card rounded-4 mb-2 overflow-hidden"
      style={{ height: "350px" }}
    >
      <SimpleBar style={{ maxHeight: "300px" }}>
        <CardBody>
          <Row>
            <Col>
              <CardTitle className="ff-sora font-size-16 primary-black fw-normal">
                Most Visited Gyms
              </CardTitle>
            </Col>
            <Col className="text-end">
              <span className="ff-sora font-size-16 secondary-black fw-bold">
                <Link
                  to={{
                    pathname: "/list-gyms",
                    search: "?type=MOSTVISITED",
                    state: { selectedTags: "MOSTVISITED" },
                  }}
                  className="ff-sora font-size-16 secondary-black fw-bold"
                >
                  View All
                </Link>
              </span>
            </Col>
          </Row>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div
                className="spinner-border"
                style={{
                  width: "3rem",
                  height: "3rem",
                  color: "#3BABA6",
                }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <Alert
              color="danger"
              className="text-center ff-sora font-size-14 secondary-black fw-normal"
            >
              {error}
            </Alert>
          ) : gyms.length === 0 ? (
            <>
              <tr>
                <td
                  colSpan="8"
                  className="text-center ff-sora font-size-16 fw-normal"
                >
                  <img
                    src={Placeholder}
                    alt={`logo`}
                    className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                  />
                </td>
              </tr>
              <tr>
                <td
                  colSpan="8"
                  className="text-center border-0 ff-sora font-size-16 fw-normal"
                >
                  No Record Found!
                </td>
              </tr>
            </>
          ) : (
            gyms.map((gym, index) => (
              <Row
                key={"gymIndex" + index}
                className="gym-row align-items-center mt-0"
              >
                <Col xs="2" sm="2" md="2">
                  <img
                    src={
                      gym.gymInfo?.files && gym.gymInfo.files.length
                        ? `${process.env.REACT_APP_IMG_URL}${
                            gym.gymInfo.files.find(
                              (val) => val.type === "image"
                            )?.data || avatar
                          }`
                        : avatar
                    }
                    alt={gym.gymInfo?.name || "Gym"}
                    className="gym-image object-fit-cover rounded-2"
                    height={40}
                    width={40}
                  />
                </Col>
                <Col xs="10" sm="10" md="10">
                  <span className="ff-sora font-size-14 primary-black fw-normal">
                    {gym.gymInfo?.name?.split(" ").slice(0, 3).join(" ") +
                      (gym.gymInfo?.name?.split(" ").length > 3 ? "..." : "")}
                  </span>
                  <br />
                  <span className="ff-sora font-size-14 secondary-black fw-normal">
                    {gym?.address?.split(" ").slice(0, 3).join(" ") +
                      (gym?.address?.split(" ").length > 3 ? "..." : "")}
                  </span>
                </Col>
              </Row>
            ))
          )}
        </CardBody>
      </SimpleBar>
    </Card>
  );
};

export default MostVisitedGyms;
